import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  windowOpen (event) {
    if (event.target.closest('a')) return

    window.open(event.currentTarget.dataset.href, '_blank')
  }
}
